$(() => {
  $("[data-decidim-map]").one("configure.decidim", (_ev, leafletMap) => {
    $("[data-decidim-geocoding]").on(
      "geocoder-suggest-coordinates.decidim",
      () => leafletMap.invalidateSize()
    );
    $("#address_map").on("decidim.voca.refresh_map", (ev, mapConfig) => {
      leafletMap.invalidateSize();
      const { marker } = mapConfig;
      if (!marker) {
        return;
      }
      leafletMap.setView([marker.latitude, marker.longitude], 17);
    });
  });
});
